import React, { useState } from "react";
import { Typography, Grid, Tooltip, IconButton } from "@mui/material";
import { DataTable } from "../../../common";
import TotalRow from "../../../common/dataTable/TotalRow";
import GetAppIcon from "@mui/icons-material/GetApp";
import { nonPaginatedSorting } from "../../../util";

const RcmStatusPageGrid = ({
    item,
    lineItemsOverPaidAndUnderpaidFields,
    setReportType,
    hoverData,
    allGrids
}) => {
    const [sortConfig, setSortConfig] = useState(
        allGrids?.map((item) => ({ [item?.name]: {} }))
    );

    const widgetsSortedData = (data, sort) => {
        return nonPaginatedSorting([sort], [...(data || [])])?.tableData;
    };
    return (
        <DataTable
            actionLevelGrid={() => (
                <Typography
                    className={`kt-font-${item?.color}`}
                    sx={{
                        fontSize: "18px",
                        fontWeight: "500",
                        pl: "15px",
                        // color:"white"
                    }}
                >
                    {item?.title}
                </Typography>
            )}
            tableLevelActions={() => (
                <>
                    <Grid item alignItems={"center"} alignContent={"center"}>
                        <Typography>
                            {
                                <TotalRow
                                    customText="Total:  "
                                    fields={lineItemsOverPaidAndUnderpaidFields}
                                    data={item?.data}
                                    whiteBg
                                />
                            }
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        sx={{ pr: "20px" }}
                        onClick={() => setReportType(item)}
                    >
                        <Tooltip title="Export">
                            <IconButton aria-label="export" size="small">
                                <GetAppIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </>
            )}
            hoverData={hoverData}
            fields={item?.fields}
            data={widgetsSortedData(
                item?.data || [],
                sortConfig[item?.name] || {}
            )}
            sort={[sortConfig[item?.name] || {}]}
            onSort={(sort) => {
                setSortConfig({ ...sortConfig, [item?.name]: sort[0] });
            }}
        />
    );
};

export default RcmStatusPageGrid;
